
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/la-growth-machine",
      function () {
        return require("private-next-pages/destinations/la-growth-machine.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/la-growth-machine"])
      });
    }
  